import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Refund } from '../../interfaces/Refund/Refund';
import { getRefund, updateRefundStatus } from '../../api/Refund';
import { RefundStatus } from '../../interfaces/Refund/RefundStatus';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { RefundStatusDropdown } from '../../components/Dropdowns/RefundStatusDropdown';

export const UpdateRefundPage = () => {
  const navigate = useNavigate();

  const { refundID: refundIDAsStr } = useParams<string>();

  const refundID = refundIDAsStr ? Number(refundIDAsStr) : undefined;

  const [refund, setRefund] = useState<Refund | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  const refreshRefund = () => {
    setLoading(true);
    getRefund(refundID!)
      .then((r) => setRefund(r))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshRefund();
  }, [refundID]);

  const handleUpdateStatus = (newStatus: RefundStatus) => {
    if (!refund) {
      return;
    }

    setLoading(true);
    updateRefundStatus(refund.id, newStatus)
      .then(() => {
        toast.success('İade talebi durumu başarıyla güncellendi');
        refreshRefund();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  const goBack = () => navigate('/sales/refunds');

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flexWrap: 'wrap',
          mb: 3,
          gap: 1.5,
        }}
      >
        <IconButton onClick={goBack} sx={{ ...sharedStyles.backIcon }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant='h5'>İade Talebi</Typography>
      </Box>

      {!refund && !loading && (
        <Typography>İade talebi yüklenirken bir hata oluştu</Typography>
      )}

      {refund && (
        <Paper
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: 400,
            height: 'fit-content',
            p: 3,
            gap: 1.5,
          }}
        >
          <TextField
            label='Kullanıcı'
            variant='outlined'
            size='small'
            value={`${refund.userFirstName} ${refund.userLastName}`}
            disabled
            fullWidth
          />

          <TextField
            label='E-Posta Adresi'
            variant='outlined'
            size='small'
            value={refund.email}
            disabled
            fullWidth
          />

          <Tooltip title={refund.productName}>
            <TextField
              label='Ürün'
              variant='outlined'
              size='small'
              value={refund.productName}
              disabled
              fullWidth
            />
          </Tooltip>

          {refund.optionName && (
            <Tooltip title={refund.optionName}>
              <TextField
                label='Varyant'
                variant='outlined'
                size='small'
                value={refund.optionName}
                disabled
                fullWidth
              />
            </Tooltip>
          )}

          <TextField
            label='İade Edilecek Adet'
            variant='outlined'
            size='small'
            value={refund.quantity.toString()}
            disabled
            fullWidth
          />

          <TextField
            label='İade Sebebi'
            variant='outlined'
            size='small'
            multiline
            value={refund.reason}
            disabled
            fullWidth
          />

          <RefundStatusDropdown
            label='Durum'
            value={refund.status}
            onChange={handleUpdateStatus}
            loading={loading}
          />
        </Paper>
      )}
    </Box>
  );
};
